import React from 'react'
import { useTranslation } from 'i18n'
import PlayButton from 'images/inline/gallery/play-button.svg'
import Modal from '@mui/material/Modal'
import Backdrop from '@mui/material/Backdrop'
import ShareIcons from 'components/ShareIcons'
import VideoPlayer from './VideoPlayer'
import analytics from 'global/AnalyticsData'
import './gallery-modal.scss'

const getitemType = uploadFile => {
  //default itemType
  let mediaType = 'photo'
  let videoArray = [
    'mov',
    'mp4',
    'avi',
    'mkv',
    'mpeg',
    'MKV',
    'MPEG',
    'MOV',
    'MP4',
    'AVI',
  ]

  if (videoArray.includes(('.' + uploadFile).split('.').pop())) {
    mediaType = 'video'
  }
  return mediaType
}

const GalleryModal = ({
  isModalOpen = false,
  item = {},
  userCanVote = false,
  onVoteClick = () => {},
  onCloseModalClick = () => {},
  zeroVotesCopy = '',
  hasVoting = false,
}) => {
  const { t } = useTranslation(['gallery', 'common'])
  const itemType = getitemType(item.uploadFile)

  const handleShareLink = (platform, link) => {
    analytics.stepEvent('step_interaction_gallery_step_social_share', {
      platform: platform,
      link: link,
      item_shared_id: item.id,
    })
  }

  const voteText =
    item.voteCount === 0
      ? zeroVotesCopy
      : t('gallery:voteCount', { count: item.voteCount })

  return (
    <Modal
      tabIndex={0}
      className={'0'}
      open={isModalOpen}
      onClose={() => {
        onCloseModalClick()
      }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      closeAfterTransition
    >
      <div className={`gallery-step-modal gallery-new-modal on`}>
        <div className="gallery-modal-container">
          <div className="gallery-modal__columns">
            {item && (
              <>
                <div className="gallery-modal__column-left">
                  <div className="gallery-modal__media-container">
                    {itemType === 'photo' && (
                      <img
                        src={`${process.env.SITE_ASSET_URL}/${item.uploadFile}`}
                        className="gallery-item__image"
                      />
                    )}
                    {itemType === 'video' && (
                      <VideoPlayer
                        videoURL={`${process.env.SITE_ASSET_URL}/${item.uploadFile}`}
                      />
                    )}
                    {itemType === 'video' && (
                      <div className="gallery-item__video-button">
                        <PlayButton />
                      </div>
                    )}
                    {itemType === 'photo' && (
                      <div className="gallery-modal__media-gradient"></div>
                    )}
                  </div>
                </div>
                <div className="gallery-modal__column-right">
                  <h3 className="gallery-modal__column-title">
                    {item.title && item.title}
                  </h3>

                  <div className="gallery-modal__content">
                    {item.caption ? `${item.caption}` : ''}
                  </div>

                  <div className="gallery-modal__submitter">
                    {t('gallery:submittedByLabeled', { name: item.firstName })}
                  </div>
                  {hasVoting && (
                    <div className="gallery-modal__votes">{voteText}</div>
                  )}
                  {hasVoting && (
                    <div className="gallery-modal__vote-button">
                      <button
                        className={
                          userCanVote
                            ? 'btn themed-button'
                            : 'btn themed-secondary'
                        }
                        disabled={userCanVote ? false : true}
                        onClick={() => onVoteClick(item.id)}
                      >
                        {userCanVote
                          ? t('gallery:vote')
                          : t('gallery:voteRecorded')}
                      </button>
                    </div>
                  )}
                  <div className="gallery-modal__social">
                    <ShareIcons
                      onShareClick={handleShareLink}
                      facebookShare={true}
                      whatsappShare={true}
                      pinterestShare={true}
                      emailShare={true}
                      twitterShare={true}
                      isText={true}
                      shareUrl={item.shareUrl}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <button
          className={`modal-close top-level-close`}
          onClick={() => {
            onCloseModalClick()
          }}
          aria-label={t('common:close')}
        ></button>
      </div>
    </Modal>
  )
}

export default GalleryModal
